import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getCachedServiceCenter } from 'utils/service-center';
import * as actionTypes from './constants';

export const activeServiceCenter = handleActions(
  {
    [actionTypes.SET_ACTIVE_SERVICE_CENTER]: (state, action) => action.payload,
  },
  getCachedServiceCenter() || '',
);

export const isDecimal = handleActions({
  [combineActions(
    actionTypes.GET_IS_DECIMAL_REQUEST,
    actionTypes.GET_IS_DECIMAL_FAILURE,
  )]: () => true,
  [actionTypes.GET_IS_DECIMAL_SUCCESS]: (action, { payload }) => payload.decimals,
}, true);

export default combineReducers({
  activeServiceCenter,
  isDecimal,
});
